export * from '@entities/san-pham/san-pham/san-pham.component';
export * from '@entities/san-pham/san-pham.route';
